module.exports = __webpack_public_path__ + "static/img/card1-2.cfc2af6.png";


//////////////////
// WEBPACK FOOTER
// ./static/img/landing/card1-2.png
// module id = oYfZ
// module chunks = 1